import { Link } from 'react-router-dom';
import { news } from '@/mocks/news';

interface RelatedNewsProps {
  eventId: string;
  categoryId: string;
}

export default function RelatedNews({ eventId, categoryId }: RelatedNewsProps) {
  const sameEvent = news.filter((item) => item.eventId === eventId);
  const sameCategory = news.filter(
    (item) => item.categoryId === categoryId && item.eventId !== eventId
  );
  const list = [...sameEvent, ...sameCategory].slice(0, 5);

  if (list.length === 0) return null;

  return (
    <section className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="px-4 md:px-6 py-4 border-b border-background-200">
        <h2 className="font-heading text-base md:text-lg font-semibold text-foreground-950 flex items-center gap-2">
          <i className="ri-links-line text-primary-600 w-5 h-5 flex items-center justify-center" />
          相关赛事资讯
        </h2>
      </div>
      <ul className="divide-y divide-background-200">
        {list.map((item) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.eventId}`}
              className="group flex items-start gap-3 px-4 md:px-6 py-4 hover:bg-background-100/70 transition-colors"
            >
              <span className="mt-0.5 shrink-0 inline-flex items-center px-2 py-0.5 rounded-full text-[11px] bg-secondary-100 text-secondary-800">
                {item.tag}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-600 line-clamp-1">{item.summary}</p>
                <span className="mt-1 inline-block text-[11px] text-foreground-500">{item.time}</span>
              </div>
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-300 group-hover:text-primary-600 transition-colors shrink-0" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}